import './Stun.css';

function Stun({amount = 0}) {


    const stunBgClass = 'stun_' + amount;
    return <div className={"stun " + stunBgClass}></div>
}

export default Stun;